import { bridge } from "@multiweb/reactCore/bridge";
import { IRunMethodResult } from "@multiweb/types/contracts";

const { replaceAllWithLookahead, replaceAll } = bridge;

/**
 * Dosadí do parametry a výsledky funkcí do templatu url adresy
 * @param url Šablona url adresy
 * @param params Pole stringů, které se dosadí do url adresy za @i (kde i je číslo)
 * @param results Pole výsledků funkcí, které se dosadí do url adresy za @i (kde i je číslo)
*/
export const processUrl = (url: string, params?: string[], results?: IRunMethodResult[]) => {
    let processedUrl = url;

    (params || []).forEach((param, index) => {
        processedUrl = replaceAllWithLookahead(processedUrl, `@${index}`, encodeURIComponent(param), "@");
    });

    (results || []).forEach((result, index) => {
        if (result)
            processedUrl = replaceAll(processedUrl, "@@" + index, encodeURIComponent(result.resultValue));
    });

    return processedUrl;
};
